import React, { useContext, useEffect, useState } from "react";
import { Container } from "components/Container";
import { useHistory } from "react-router";
import * as atoms from "./CrearCarpetasLegajoStore";
import { useAtom } from "jotai";
import { useModalConfirmar } from "store/global";
import { ModalConfirmar } from "components/Modal/ModalConfirmar";
import {CarpetaLegajoRegistro} from "./carpeta-legajo-registro";
import CarpetaService from "services/CarpetaService";

const CrearCarpetasLegajosPage=()=>{
    let history = useHistory();
    const [loading, setLoading] = useState(false);
    const [carpetasLegajos]=useAtom(atoms.carpetasLegajos);
    const cerrarModalConfirmacion = useModalConfirmar(state => state.cerrarModal);

    const onClickRetonarListarTipoDocumentos=()=>{
        history.push("/configuracion/carpetas-legajos/listar");
    }
    const onClickBtnCancelarModal=()=>{

        cerrarModalConfirmacion();
    }
    const onClickBtnConfirmarModal=async ()=>{

        try {
            setLoading(true);
            const _carpeta= await CarpetaService.insertar(carpetasLegajos);
            cerrarModalConfirmacion();
            history.push("/configuracion/carpetas-legajos/listar");
            
        } catch (error) {
            console.error(error);
            
        }finally{
            setLoading(false);
        }
    }
    return(
        <Container titulo="Crear Carpeta" onClickRetornar={onClickRetonarListarTipoDocumentos}>
            <CarpetaLegajoRegistro/>
            <ModalConfirmar
                loading={loading}
                mensaje="¿Está seguro de guardar la Carpeta? "
                onClickBtnCancelar={onClickBtnCancelarModal}
                onClickBtnConfirmar={onClickBtnConfirmarModal} />

        </Container>
    )

}
export default CrearCarpetasLegajosPage;